var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAwardsActive = function SvgAwardsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#awards-active_svg__a)",
    d: "M19.84 6h-2.77s-.05.01-.08.02V3H7v3H4.22C3.55 6 3 6.55 3 7.22v2.54c0 2.39 2.91 3.5 4.21 3.59.53 1.88 2.11 3.3 4.07 3.59v3.57H8.32c-.41 0-.75.34-.75.75s.34.75.75.75h7.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.04v-3.58a4.977 4.977 0 0 0 4.01-3.58c1.27-.06 4.26-1.16 4.26-3.59V7.22c0-.67-.55-1.22-1.22-1.22h.01ZM4.5 9.75V7.5H7v4.3c-.85-.17-2.5-.84-2.5-2.04v-.01Zm15.06 0c0 1.23-1.73 1.9-2.56 2.06V7.48s.05.02.08.02h2.48v2.25Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "awards-active_svg__a",
    x1: 3,
    x2: 5.86,
    y1: 3,
    y2: 24.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })))));
};
export default SvgAwardsActive;